export var ChainLeadingContent;
(function (ChainLeadingContent) {
    ChainLeadingContent["Ahead"] = "ahead";
    ChainLeadingContent["Astern"] = "astern";
    ChainLeadingContent["ToPort"] = "to port";
    ChainLeadingContent["ToStarboard"] = "to starboard";
    ChainLeadingContent["RoundTheBow"] = "round the bow";
    ChainLeadingContent["UpAndDown"] = "up and down";
})(ChainLeadingContent || (ChainLeadingContent = {}));
//# sourceMappingURL=ChainLeadingContent.js.map